import { getGlobalSubscriptionState } from '../../analytics/shared';

const PRODUCT_CARD_QUANTITY_ADD_TO_CART = 1;

export default class Selectors {
  isSubscription = (buttonSubscriptionState = null) => {
    if (buttonSubscriptionState) {
      return buttonSubscriptionState === 'subscription';
    }

    return getGlobalSubscriptionState() === 'subscription';
  };

  getQuantity = () => PRODUCT_CARD_QUANTITY_ADD_TO_CART;

  getVariantData = ({ variantId }) => window.variantDataSelector.getData(variantId);
}
